import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon, TransparentButton, RouteLink } from '@sumtotal/react-foundation';
import { useTranslation } from 'react-i18next';

const ActionButton = styled(TransparentButton)`
  color: ${(props) => props.theme.variables.leftNavParentColor};
  margin-right: 0.75rem;
  margin-left: 0.75rem;
  padding: 0.125rem 0.5rem;
  min-height: 1.25rem;
  min-width: 4.375rem;
  font-size: 0.625rem;
  font-weight: normal;
  text-transform: none;
  border-radius: 0.6875rem;
  border: 0.0625rem solid;
  &:hover,
  &:focus {
    border: 0.0625rem solid;
    background-color: ${(p) => p.theme.variables.topbarNavHoverStateBackground};
    color: ${(p) => p.theme.variables.topbarNavHoverStateTextColor};
  }
  &:active {
    color: ${(p) => p.theme.variables.topbarNavActiveStateTextColor};
    border: 0.0625rem solid;
    background-color: ${(p) => p.theme.variables.topbarNavActiveStateBackground};
  }

  .MuiButton-iconSizeSmall {
    margin-right: 0.25rem;
    margin-left: 0;
    > *:first-child {
      font-size: 0.625rem;
    }
  }
`;

const DomainText = styled.span`
  font-weight: normal;
  font-size: 0.75rem;
  color: ${(props) => props.theme.variables.leftNavParentColor};
  padding-left: 0.25rem;
  max-width: 17.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const DomainLabel = styled(DomainText)`
  font-weight: 600;
`;

/**
 *  Component for Domain Switcher.
 *  It is used in the MegaMenuHeader
 */
const DomainSwitcher = ({ domainName, domainSwitchUrl, callbackEvent }) => {
  const { t } = useTranslation(['TRANSLATIONS_RCORE_TOPNAV']);

  const Link = React.forwardRef((props, ref) => (
    <RouteLink
      ref={ref}
      txtarialabel={t('RCORE_TOPNAV_MENU_LABEL_CHANGE_DOMAIN')}
      txtariadescribedby="domainName"
      {...props}
    />
  ));
  Link.displayName = 'domainChangeButton';

  return (
    <>
      <DomainLabel>{t('RCORE_TOPNAV_MENU_LABEL_DOMAIN')}:</DomainLabel>
      <DomainText id="domainName">{domainName}</DomainText>
      <ActionButton
        size="small"
        component={Link}
        path={domainSwitchUrl}
        onClick={callbackEvent}
        startIcon={<Icon iconType="MaterialIcon" iconName="Repeat" size={0.625} />}
      >
        {t('RCORE_TOPNAV_MENU_LABEL_CHANGE')}
      </ActionButton>
    </>
  );
};

DomainSwitcher.propTypes = {
  /**
   * Domain Name
   */
  domainName: PropTypes.string,
  /**
   * Domain Switch Url
   */
  domainSwitchUrl: PropTypes.string,
  /**
   * Parent callback event
   */
  callbackEvent: PropTypes.func
};

DomainSwitcher.defaultProps = {
  domainName: '',
  domainSwitchUrl: '',
  callbackEvent: () => {}
};

export default DomainSwitcher;
